import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Topbar from '../components/layout/Topbar';
import { Panel, PanelHead, PanelBody, Button, Spinner } from '../components/ui';
import { updatePrezziDisponibilita } from '../services/firebase';
import { updateBeach } from '../services/firebase';

export default function Availability() {
  const { beach, refreshBeach, admin } = useAuth();
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const [form, setForm] = useState({
    ombrelloni_qty: beach?.disponibilita?.ombrelloni ?? 0,
    ombrelloni_price: beach?.prezzi?.ombrelloni ?? 0,
    lettini_qty: beach?.disponibilita?.lettini ?? 0,
    lettini_price: beach?.prezzi?.lettini ?? 0,
    cabine_qty: beach?.disponibilita?.cabine ?? 0,
    cabine_price: beach?.prezzi?.cabine ?? 0,
  });

  const set = (f) => (e) => setForm((p) => ({ ...p, [f]: Number(e.target.value) }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateBeach(admin.beachCode, {
        disponibilita: {
          ombrelloni: form.ombrelloni_qty,
          lettini: form.lettini_qty,
          cabine: form.cabine_qty,
        },
        prezzi: {
          ombrelloni: form.ombrelloni_price,
          lettini: form.lettini_price,
          cabine: form.cabine_price,
        },
      });
      await refreshBeach();
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } finally {
      setSaving(false);
    }
  };

  const services = [
    { key: 'ombrelloni', label: 'Ombrelloni', icon: '☂️' },
    { key: 'lettini', label: 'Lettini', icon: '🛏' },
    { key: 'cabine', label: 'Cabine', icon: '🏠' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Topbar
        title="Disponibilità & Prezzi"
        actions={
          <Button
            variant={saved ? 'ghost' : 'sand'}
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? <Spinner size={14} /> : saved ? '✓ Salvato' : 'Salva modifiche'}
          </Button>
        }
      />

      <div style={{ padding: '24px 28px', overflowY: 'auto', flex: 1 }}>
        <Panel style={{ marginBottom: '16px' }}>
          <PanelHead title="Posti disponibili & tariffe" subtitle="Modifiche applicate a tutti i giorni non ancora prenotati" />
          <PanelBody>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
              {services.map(({ key, label, icon }) => (
                <div key={key} style={{
                  background: 'var(--surface)', border: '1px solid var(--border)',
                  borderRadius: 'var(--radius-md)', padding: '16px',
                }}>
                  <div style={{ fontSize: '20px', marginBottom: '10px' }}>{icon}</div>
                  <div style={{ fontSize: '12px', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '14px' }}>
                    {label}
                  </div>

                  {[
                    { label: 'Posti totali', field: `${key}_qty`, suffix: 'posti' },
                    { label: 'Prezzo al giorno', field: `${key}_price`, prefix: '€' },
                  ].map(({ label: lbl, field, suffix, prefix }) => (
                    <div key={field} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                      <span style={{ fontSize: '13px', color: 'var(--text-soft)' }}>{lbl}</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {prefix && <span style={{ fontSize: '12px', color: 'var(--sand)' }}>{prefix}</span>}
                        <input
                          type="number" min="0"
                          value={form[field]}
                          onChange={set(field)}
                          style={{
                            width: '64px', background: 'var(--navy)',
                            border: '1px solid var(--border-mid)', borderRadius: 'var(--radius-sm)',
                            color: prefix ? 'var(--sand)' : '#fff',
                            textAlign: 'center', padding: '5px 6px',
                            fontSize: '14px', fontFamily: 'var(--font-sans)',
                          }}
                        />
                        {suffix && <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{suffix}</span>}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </PanelBody>
        </Panel>

        <Panel>
          <PanelHead title="Servizi offerti" subtitle="Visibili nella scheda lido dell'app" />
          <PanelBody>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {(beach?.servizi || []).map((s, i) => (
                <div key={i} style={{
                  padding: '5px 14px', borderRadius: '20px',
                  background: 'var(--surface)', border: '1px solid var(--border)',
                  fontSize: '12.5px', color: 'var(--text-soft)',
                }}>
                  {s}
                </div>
              ))}
              {(!beach?.servizi?.length) && (
                <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
                  Nessun servizio configurato — modificabile dalle impostazioni lido.
                </span>
              )}
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>
  );
}
